import React from "react";
import { Container, Row, Col, Nav, Tab, Image } from 'react-bootstrap';

import healthCare from "../Assets/health-care.png"

export default function DomainsBlock() {
    return (
        <section className='padding-section-large px-5'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Where We Make an <span className="text-gradient-1">Impact</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Every industry comes with its own challenges. We create software that responds to the pressures, pace, and priorities of each industry. </h5>
                    </Col>
                </Row>
                <Tab.Container defaultActiveKey="healthcare">
                    {/* Top Content */}

                    {/* Text */}

                    <Tab.Content>
                        <Tab.Pane eventKey="fintech">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>FinTech</h3>
                                    <p>Financial solutions with secure platforms.</p>
                                </Col>
                            </Row>
                        </Tab.Pane>

                        <Tab.Pane eventKey="healthcare">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>Healthcare</h3>
                                    <p>
                                        Platforms shaped around compliance, patient data integrity,
                                        and operational continuity.
                                    </p>
                                </Col>
                            </Row>

                        </Tab.Pane>

                        <Tab.Pane eventKey="ecommerce">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>E-commerce</h3>
                                    <p>Scalable and high-performance online stores.</p>
                                </Col>
                            </Row>

                        </Tab.Pane>

                        <Tab.Pane eventKey="saas">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>SaaS & Technology</h3>
                                    <p>Cloud-native SaaS applications.</p>
                                </Col>
                            </Row>

                        </Tab.Pane>

                        <Tab.Pane eventKey="logistics">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>Logistics & Supply Chain</h3>
                                    <p>Efficient supply chain systems.</p>
                                </Col>
                            </Row>

                        </Tab.Pane>

                        <Tab.Pane eventKey="education">
                            <Row className="border bg-gradient-1">
                                {/* Image */}
                                <Col md={6} className="p-0">
                                    <Image src={healthCare} className="img-fluid" />
                                </Col>
                                <Col md={6} className="p-5">
                                    <h3>Education</h3>
                                    <p>Modern e-learning platforms.</p>
                                </Col>
                            </Row>

                        </Tab.Pane>
                    </Tab.Content>
                    <Row>
                        {/* Bottom Tabs */}
                        <Nav className="justify-content-between bottom-tabs bg-gradient-1">
                            <Nav.Item>
                                <Nav.Link eventKey="fintech">FinTech</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="healthcare">Healthcare</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="ecommerce">E-commerce</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="saas">SaaS & Technology</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="logistics">Logistics & Supply Chain</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="education">Education</Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Row>
                </Tab.Container>
            </Container>
        </section>
    )
}